// function that takes a number, a jquery selector to a div (or p)
// in that container it toggles the .plural or .singular class
// depending on the number
// it also fills the .count span with the number
// if there's no plural, singular, or count span, it throws an error
function writeCount(number, container) {
  if (container.find('.count').length === 0) {
    throw new Error('No .count span found in container');
  }
  if (container.find('.plural').length === 0 && container.find('.singular').length === 0) {
    throw new Error('No .plural or .singular span found in container');
  }
  container.find('.count').text(number);
  if (number === 1) {
    container.find('.plural').hide();
    container.find('.singular').show();
  } else {
    container.find('.singular').hide();
    container.find('.plural').show();
  }
}